const paths = {
    // home: '/',
    not_found: '/not-found',
    login: '/login',
    register: '/cadastro',
    password_recovery: '/recadastrar-senha',
    validator: '/validar-receita',
    prescription: '/receita',
}

export default paths